// extracted by mini-css-extract-plugin
export var table = "_zb-0";